import { getFormErrors } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import type { VehicleFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { VehicleFormCranes } from "./vehicle-form-cranes";
import { VehicleFormExtended } from "./vehicle-form-extended";
import { VehicleFormGeneral } from "./vehicle-form-general";

export function VehicleForm() {
	/** Context */
	const methods = useFormContext<VehicleFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tabs
			groups={[
				{
					name: "general",
					panels: [
						{
							label: t("general.general"),
							panel: () => <VehicleFormGeneral />,
							errors: getFormErrors(methods.formState.errors, [
								"licensePlate",
								"type",
								"vin",
								"hsn",
								"tsn",
								"manufacturer",
								"fuelType",
							]),
							cyId: "vehicle-form-general-tab",
						},
						{
							label: t("vehicles.cranes"),
							panel: () => <VehicleFormCranes />,
							errors: getFormErrors(methods.formState.errors, []),
							cyId: "vehicle-form-general-tab",
						},
						{
							label: t("general.extended"),
							panel: () => <VehicleFormExtended />,
							errors: getFormErrors(methods.formState.errors, []),
							cyId: "vehicle-form-extended-tab",
						},
					],
				},
			]}
		/>
	);
}
